import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { Provider } from "@angular/core";

import { HttpErrorInterceptor } from "./http-error.interceptor";
import { I18nNoCacheInterceptor } from "./i18n-no-cache.interceptor";
import { LanguageHeaderInterceptor } from "./language-header.interceptor";

export const provideHttpInterceptors = (): Provider[] => {
  return [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpErrorInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LanguageHeaderInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: I18nNoCacheInterceptor,
      multi: true,
    },
  ];
};
